import * as React from "react";
import { forwardRef } from "react";
const SvgSend = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.67496 17.5L19.1666 10L1.67496 2.5L1.66663 8.33333L14.1666 10L1.66663 11.6667L1.67496 17.5Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgSend);
export default ForwardRef;
